module.exports = __webpack_public_path__ + "static/img/tldr-phone-middle.6ad4b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device/tldr-phone-middle.png
// module id = kUh/
// module chunks = 0